<ion-chip>
  <ion-badge [color]="clientColor"></ion-badge>
  <ion-label>
    {{ clientName }}
  </ion-label>
</ion-chip>